<div class="search-bar">
  <div class="search-field">
    <mat-icon class="search-icon">search</mat-icon>

    <button type="button" class="search-scope" [matMenuTriggerFor]="scopeMenu" matTooltip="Choose what to search">
      <span>{{ scopeLabels[scope] }}</span>
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #scopeMenu="matMenu" class="search-scope-menu">
      @for (option of scopeOptions; track option.value) {
        <button mat-menu-item (click)="scope = option.value" [class.selected]="scope === option.value">
          <mat-icon>{{ option.icon }}</mat-icon>
          <span class="scope-option">
            <span class="scope-option-label">{{ option.label }}</span>
            <span class="scope-option-hint">{{ option.hint }}</span>
          </span>
        </button>
      }
    </mat-menu>

    <span class="search-divider"></span>

    @switch (scope) {
      @case ('local') {
        <input
          type="text"
          name="search"
          autocomplete="off"
          placeholder="Filter this page"
          [(ngModel)]="message"
          (keyup)="searchLocal($event.target.value)"
          />
      }
      @case ('users') {
        <input
          type="text"
          name="search"
          autocomplete="off"
          placeholder="User's full email address"
          [(ngModel)]="searchUsersText"
          (keyup.enter)="runSearch()"
          />
      }
      @case ('assets') {
        <input
          type="text"
          name="search"
          autocomplete="off"
          placeholder="Asset name or partial name (excluding health sensors)"
          [(ngModel)]="assetSearchText"
          (keyup.enter)="runSearch()"
          />
      }
      @case ('logs') {
        <input
          type="text"
          name="search"
          autocomplete="off"
          placeholder="Unit sequence # or test result"
          [(ngModel)]="searchLogText"
          (keyup.enter)="runSearch()"
          />
      }
    }

    @if (scope === 'local') {
      <button
        type="button"
        class="search-action keep-filter"
        [class.active]="saveFilter"
        [attr.aria-pressed]="saveFilter"
        [matTooltip]="saveFilter ? 'Filter is kept when you navigate (click to stop)' : 'Keep this filter when navigating'"
        (click)="toggleKeepFilter()"
        >
        <mat-icon>push_pin</mat-icon>
      </button>
    } @else {
      <button type="button" class="search-action search-go" matTooltip="Search" (click)="runSearch()">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    }
  </div>
</div>
